import { BankAccount, PaymentMethod, StripePaymentMethod } from 'types/payment';

export const isBankPaymentMethod = (paymentMethod: PaymentMethod): paymentMethod is BankAccount => {
	return paymentMethod.hasOwnProperty('routingNumber');
};

export const isStripePaymentMethod = (paymentMethod: PaymentMethod): paymentMethod is StripePaymentMethod => {
	return paymentMethod.hasOwnProperty('stripePaymentMethodId');
};
